module.exports = __webpack_public_path__ + "img/5_f88dec0ad.png";